import React from 'react';
import { ArrowRight, CheckCircle, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { products as fallbackProducts } from '../data/siteData';
import { getContentIcon, useCollectionData } from '../services/contentApi';
import './HeroSection.css';

const HeroSection = () => {
  const { items: products } = useCollectionData('products', fallbackProducts);
  const previewProducts = products.slice(0, 4);

  return (
  <section className="hero-section">
    <div className="container hero-grid">
      <div className="hero-copy">
        <div className="hero-badge">
          <ShieldCheck size={17} aria-hidden="true" />
          Trusted by healthcare facilities nationwide
        </div>
        <h1>
          Premium hospital linens with a human standard of care.
        </h1>
        <p>
          NovaCareLinens delivers CDC/OSHA-compliant bed sheets, towels,
          pillowcases, and patient textiles to hospitals, clinics, and
          long-term care facilities.
        </p>
        <div className="hero-actions">
          <Link className="btn-primary" to="/products">
            Explore products <ArrowRight size={18} aria-hidden="true" />
          </Link>
          <Link className="btn-secondary" to="/contact">
            Request a quote
          </Link>
        </div>
        <div className="hero-trust-list" aria-label="NovaCareLinens trust indicators">
          {['CDC aligned', 'OSHA ready', 'HLAC partner network', 'Bulk pricing'].map((item) => (
            <span key={item}>
              <CheckCircle size={16} aria-hidden="true" />
              {item}
            </span>
          ))}
        </div>
      </div>

      <div className="hero-visual surface-card">
        <div className="hero-image-wrap">
          <img
            src="/phl-linen-visual.png"
            alt="Clean hospital bed linens and folded towels prepared for clinical use"
          />
        </div>
        <div className="hero-visual-panel">
          <div>
            <p className="hero-panel-label">Clinical textile program</p>
            <strong>250 TC percale, terry cotton, and non-woven SKUs</strong>
          </div>
          <span>Net 30</span>
        </div>
        <div className="hero-product-stack" aria-label="Featured in-stock products">
          {previewProducts.map((product, index) => {
            const { name, spec, tone, icon } = product;
            const Icon = getContentIcon(icon);
            return (
              <div className="hero-product-row" key={name || index} style={{ '--delay': `${index * 80}ms` }}>
                <span className={`icon-circle tone-${tone || 'blue'}`}>
                  <Icon size={21} strokeWidth={1.8} aria-hidden="true" />
                </span>
                <div>
                  <strong>{name}</strong>
                  <small>{spec}</small>
                </div>
                <em>In stock</em>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
  );
};

export default HeroSection;
